import { render, staticRenderFns } from "./AddBankAccountModal.vue?vue&type=template&id=1855321c&"
import script from "./AddBankAccountModal.vue?vue&type=script&lang=js&"
export * from "./AddBankAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports